'use client';

import Container from '@mui/material/Container';
import {useTranslation} from 'react-i18next';
import type {Media} from '../../model';
import {MediaGallery, MediaType} from '../gallery';
import {Section} from '../primitives';

export interface DetailMasterplanSectionProps {
  media?: Media;
  onView?: () => void;
}

export function DetailMasterplanSection({media, onView}: DetailMasterplanSectionProps) {
  const {t} = useTranslation();
  if (!media) {
    return null;
  }
  return (
    <Section tone="subtle">
      <Container>
        <MediaGallery
          assets={[{type: MediaType.Image, src: media.src, alt: t('masterplan')}]}
          title={t('masterplan')}
          showViewAll
          onOpen={onView}
        />
      </Container>
    </Section>
  );
}

DetailMasterplanSection.displayName = 'DetailMasterplanSection';
